// Cómo se nombra a quien hizo una acción: el back guarda el sub de Cognito o el nombre del servicio.
import type { TFunction } from 'i18next';
import { isUuid } from './displayName';
import { shortId } from './shortId';

export interface ActorDirectory {
    selfSub: string | null;
    selfName: string | null;
    /** Nombre por sub de los usuarios que la sesión puede consultar. */
    names: ReadonlyMap<string, string>;
}

export function actorLabel(
    actor: string | null | undefined,
    directory: ActorDirectory,
    t: TFunction,
): string {
    if (!actor) return '—';
    if (actor === directory.selfSub && directory.selfName) {
        return t('common:actor.self', { name: directory.selfName });
    }
    const name = directory.names.get(actor);
    if (name) return name;
    if (isUuid(actor)) return t('common:actor.user', { id: shortId(actor) });
    return t('common:actor.system', { name: actor });
}
